import { Auth, Browser as NativeBrowser, Widgets, LiveActivities, LocalAuthentication, ProtectedStore, KeepAwake, Print, StoreReview, QuickActions, Location, FileSystem, Audio, CameraView, Share, Open, PhotoLibrary, MapServices, AppTracking, AppIcon, ScreenOrientation, ScreenCapture, Purchases, ImageManipulator, Device, Crypto as NativeCrypto, Localization, Motion, BackgroundTasks, AppIntents, DeviceAttestation, Contacts, Calendar, WidgetUI, VNDocumentCameraViewController, DataScannerViewController, CNContactViewController, CNMutableContact, CNContactStore, MFMailComposeViewController, MFMessageComposeViewController, Clipboard as NativeClipboard, Barometer as NativeBarometer, LightSensor as NativeLightSensor, Pedometer as NativePedometer, Battery as NativeBattery, Brightness as NativeBrightness, SpeechSynthesis as NativeSpeechSynthesis, AppInfo, Color, Database, Compose, Fonts, DocumentPicker, Haptics, ImagePicker, LaunchScreen, MenuAction, Menu as NativeMenu, ContextMenu as NativeContextMenu, Notifications, Network as NativeNetwork, SecureStore as NativeSecureStore, Storage, Speech as NativeSpeech, Updates as NativeUpdates, SplitView, Swift, TextInput, ToolbarHost, ToolbarItem, UI as NativeUI, ReservedRegions, ZoomTransitionAlignmentRectDetector, ZoomTransitionEnabler, ZoomTransitionSource } from "./platform";
import { SafeAreaProvider, SafeAreaView, initialWindowMetrics } from "./safe-area-context";
function currentPlatform() {
  var _Reflect_get;
  var defined = (_Reflect_get = Reflect.get(globalThis, "__ONE_PLATFORM__")) !== null && _Reflect_get !== void 0 ? _Reflect_get : typeof process !== "undefined" ? process.env.ONE_PLATFORM : void 0;
  return defined === "ios" || defined === "android" ? defined : "web";
}
var iOS = Object.freeze({
  ...Swift,
  VNDocumentCameraViewController,
  DataScannerViewController,
  CNContactViewController,
  CNMutableContact,
  CNContactStore,
  MFMailComposeViewController,
  MFMessageComposeViewController,
  WidgetUI,
  CameraView,
  Color: Color.ios,
  MenuAction,
  SplitView,
  ToolbarHost,
  BarButtonItem: ToolbarItem,
  ZoomTransitionAlignmentRectDetector,
  ZoomTransitionEnabler,
  ZoomTransitionSource
});
var Android = Object.freeze({
  ...Compose,
  Color: Color.android,
  Menu: NativeMenu,
  ContextMenu: NativeContextMenu,
  CameraView
});
var SafeArea = Object.freeze({
  Provider: SafeAreaProvider,
  View: SafeAreaView,
  initialMetrics: initialWindowMetrics
});
var UI = Object.freeze({
  ...NativeUI,
  Fonts,
  SafeArea,
  TextInput,
  ReservedRegions
});
var One = Object.freeze({
  get platform() {
    return currentPlatform();
  },
  openURL: Open.openURL,
  openShare: Open.openShare,
  openSettings: Open.openSettings,
  AppInfo,
  Database,
  Widgets,
  LiveActivities,
  LocalAuthentication,
  ProtectedStore,
  KeepAwake,
  Print,
  StoreReview,
  QuickActions,
  Location,
  FileSystem,
  Audio,
  Share,
  PhotoLibrary,
  MapServices,
  AppTracking,
  AppIcon,
  ScreenOrientation,
  ScreenCapture,
  Purchases,
  ImageManipulator,
  Device,
  Crypto: NativeCrypto,
  Localization,
  Motion,
  BackgroundTasks,
  AppIntents,
  DeviceAttestation,
  Contacts,
  Calendar,
  iOS,
  Android,
  UI,
  Notifications,
  Clipboard: NativeClipboard,
  Barometer: NativeBarometer,
  LightSensor: NativeLightSensor,
  Pedometer: NativePedometer,
  Battery: NativeBattery,
  Brightness: NativeBrightness,
  SpeechSynthesis: NativeSpeechSynthesis,
  Haptics,
  LaunchScreen,
  Network: NativeNetwork,
  Auth,
  Browser: NativeBrowser,
  ImagePicker,
  DocumentPicker,
  SecureStore: NativeSecureStore,
  Storage,
  Speech: NativeSpeech,
  Updates: NativeUpdates
});
export {
  One
};
//# sourceMappingURL=one.js.map
